import React from 'react'
import {IconAdd, IconFilters, IconGlobe} from '../Icons'
import {PageProps} from '../components/PageRouter'
import {Box, Button, Container} from '@mui/material'
import {useSuspense} from '@data-client/react'
import {TripResource, TripsFilter} from '../lib/model'
import {TripFilterForm, TripTable} from '../components/Trip'
import {ActionHeader} from '../components'
import {useToggle} from '../lib'

export default function TripListPage({session}: PageProps) {
  const filters = useToggle(false)
  const [qry, updateQry] = React.useState<TripsFilter>({scope: session.euid(), tags: []})
  const trips = useSuspense(TripResource.getList, qry)

  const onSearch = (data: TripsFilter) => {
    updateQry(data)
  }

  return (
    <Container maxWidth="md">
      <ActionHeader title="Trips">
        <Box className="app-flex" flexWrap="wrap">
          <Button title="Global View" href="/globe" color="primary" variant="contained" size="small">
            <IconGlobe />
          </Button>
          &nbsp;
          <Button title="Add Trip" href="./add-trip" color="primary" variant="contained" size="small">
            <IconAdd />
          </Button>
          &nbsp;
          <Button title="Filter Trips" onClick={filters.toggle} color="primary" variant="contained" size="small">
            <IconFilters />
          </Button>
        </Box>
      </ActionHeader>
      <TripFilterForm show={filters} onSearch={onSearch} />
      <Box mt={5}>
        <TripTable trips={trips} />
      </Box>
    </Container>
  )
}
